import { IonModal, IonHeader, IonToolbar, IonTitle, IonButtons, IonButton, IonIcon, IonContent } from '@ionic/react';
import { close, trophy } from 'ionicons/icons';
import { Badge } from '../../types/index';
import { cacheBustImageUrl } from '../../utils/imageUtils';
import { badgeModalService } from '../../services/badgeModalService';
import { Fireworks } from './Fireworks';

interface BadgeEarnedModalProps {
  isOpen: boolean;
  badge: Badge | null;
  onClose: () => void;
}

export function BadgeEarnedModal({ isOpen, badge, onClose }: BadgeEarnedModalProps) {
  const handleClose = () => {
    badgeModalService.close();
    onClose();
  };

  if (!badge) {
    return null;
  }

  return (
    <>
      <Fireworks isActive={isOpen} />
      <IonModal isOpen={isOpen} onDidDismiss={handleClose}>
        <IonHeader>
        <IonToolbar>
          <IonTitle>Badge Earned!</IonTitle>
          <IonButtons slot="end">
            <IonButton onClick={handleClose}>
              <IonIcon icon={close} slot="icon-only" />
            </IonButton>
          </IonButtons>
        </IonToolbar>
      </IonHeader>
      <IonContent className="ion-padding">
        <div className="flex flex-col items-center justify-center py-8 px-4">
          {/* Celebration Message */}
          <div className="text-center mb-6">
            <h2 className="text-2xl font-bold text-gray-900 mb-2">
              Congratulations!
            </h2>
            <p className="text-lg text-gray-700">
              You earned the <strong>{badge.name}</strong> badge!
            </p>
          </div>

          {/* Badge Image */}
          <div className="mb-6 flex items-center justify-center">
            {badge.imageUrl ? (
              <img
                src={cacheBustImageUrl(badge.imageUrl)}
                alt={badge.name}
                className="w-32 h-32 object-contain"
              />
            ) : (
              <IonIcon
                icon={trophy}
                className="w-32 h-32"
                style={{
                  color: 'var(--ion-color-primary)',
                }}
              />
            )}
          </div>

          {/* Badge Description */}
          <div className="text-center mb-8 max-w-md">
            <p className="text-base text-gray-700">
              {badge.description}
            </p>
          </div>

          {/* Close Button */}
          <IonButton
            color="primary"
            size="large"
            onClick={handleClose}
            className="mt-4"
          >
            Awesome!
          </IonButton>
        </div>
      </IonContent>
    </IonModal>
    </>
  );
}
